import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

window.UIkit = UIkit;

// loads the Icon plugin
UIkit.use(Icons);